// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let AttributeList = require("./AttributeList.bs.js");
let PropertyStrings = require("../Strings/PropertyStrings.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function PropertyAttributes(props) {
  let fn = param => ({
    value: param[0],
    title: PropertyStrings.displayPropertyAttributeSuffix(param[1])
  });
  let attributes = Stdlib_List.map(props.propertyAttributes, fn);
  return JsxRuntime.jsx(AttributeList.make, {
    data: Stdlib_List.toArray(attributes),
    size: props.size
  });
}

let make = PropertyAttributes;

exports.make = make;
/* AttributeList Not a pure module */
